export default __webpack_public_path__ + "static/media/BioStats_2018_AdjustedRsquared.8deafea5.pdf";